module.exports = __webpack_public_path__ + "static/img/like_0.ad166a9b.svg";